import React from 'react'
import { Report } from '../_models/Report.model'
import { ClientType } from '../_models/Client.model'
import { FaCircleInfo } from 'react-icons/fa6'
import "../appComponents/Admin/AddUsers/AddUsers.css"

interface ReportsTableProps {
  reports: Report[]
  noResultsMessage: string
  viewReportHandler: (report: Report) => void
  duplicateReportHandler?: (report: Report) => void
  deleteReportHandler?: (report: Report) => void
  canDuplicate?: boolean
  canDelete?: boolean
}

export const ReportsTable: React.FC<ReportsTableProps> = ({
  reports, noResultsMessage, viewReportHandler, duplicateReportHandler, deleteReportHandler, canDuplicate, canDelete
}) => {
  return (
    <>
      {reports.length > 0 ? (
        <div className="au-table-wrap" style={{ marginTop: 24 }}>
          <table className="au-table">
            <thead>
              <tr>
                <th>Created Date</th>
                <th>Score</th>
                <th style={{ width: "220px", textAlign: "right" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {reports.map((report) => (
                <tr key={report.Id}>
                  <td>{report.ReportedDate}</td>
                  <td>
                    <span className={`au-role-pill ${report.Client?.Type === ClientType.NDIS ? "info" : "admin"}`}>
                      {report.Client?.Type === ClientType.NDIS ? "Pass/Fail" : report.TotalScore}
                    </span>
                  </td>
                  <td style={{ textAlign: "right" }}>
                    <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                      <button
                        className="btn-action btn-success"
                        onClick={() => viewReportHandler(report)}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 4 }}>
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
                        </svg>
                        View Report
                      </button>
                      {canDuplicate && duplicateReportHandler && (
                        <button
                          className="btn-action btn-warning"
                          onClick={() => duplicateReportHandler(report)}
                        >
                          Duplicate
                        </button>
                      )}
                      {canDelete && deleteReportHandler && (
                        <button
                          className="btn-action btn-danger"
                          onClick={() => deleteReportHandler(report)}
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="au-empty" style={{ padding: "40px" }}>
          <FaCircleInfo style={{ fontSize: "1.2rem", marginBottom: "12px", color: "#9CA3AF" }} />
          <div>{noResultsMessage}</div>
        </div>
      )}
    </>
  )
}
